<template>
  <div id="introduce">
    <div class="row">
      <div class="col-md-12">
        <img src="/static/images/introduce/dobutsusan_syokai_1.jpg" class="img-fluid" alt="どうぶつさんしょうかい">
        <img src="/static/images/introduce/dobutsusan_syokai_2.jpg" class="img-fluid" alt="どうぶつさんしょうかい">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: 'どうぶつさんしょうかい',
    name: 'introduce',
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Introduce.vue